/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2023-09-06 15:33:15
 * @LastEditors: 郗志源 xizhiyuan@toseesoft.net
 * @Description: System Logs 日志
 * @Do not edit
 */

import Home from "../pages/Home";
import Project from "../pages/Project";
import CityList from "../pages/CityList";
import Areatoraise from "../pages/Areatoraise";
import Personal from "../pages/Personal";
import Belows from "../components/common/Belows";
import DataDownload from "../components/common/DataDownload";
import PolicyPaper from "../components/common/PolicyPaper";
import AboutUs from "../components/common/AboutUs";
import RequestConditions from "../components/common/RequestConditions";
import RequestProblem from "../components/common/RequestProblem";
import RequestFlow from "../components/common/RequestFlow";

let routers = [
  { path: "/", name: "home", component: Home, title: "首页", views: true },
  { path: "/home", name: "home", component: Home, title: "首页", views: true },
  {
    path: "/project",
    name: "project",
    component: Project,
    isLogin: true,
    title: "房源项目",
    views: true,
  },
  {
    path: "/citylist",
    name: "citylist",
    component: CityList,
    isLogin: true,
    title: "地图找房",
    views: true,
  },
  // {path:"/areatoraise", name:"areatoraise", component:Areatoraise, isLogin:true, title:'区筹资格证申请',views:false},
  { path: "/belows", name: "belows", component: Belows, isLogin: true, title: '房源项目详情', views: true },
  // {path:"/personal", name:"personal", component:Personal, isLogin:true, title:'个人中心',views:false},
  { path: "/dataDownload", name: "dataDownload", component: DataDownload, isLogin: true, title: '附件管理', views: true },
  { path: "/policyPaper", name: "policyPaper", component: PolicyPaper, isLogin: true, title: '政策文件', views: true },
  { path: "/aboutUs", name: "aboutUs", component: AboutUs, isLogin: true, title: '关于我们', views: true },
  { path: "/requestConditions", name: "requestConditions", component: RequestConditions, isLogin: true, title: '申请条件', views: true },
  { path: "/requestProblem", name: "requestProblem", component: RequestProblem, isLogin: true, title: '常见问题', views: true },
  { path: "/requestFlow", name: "requestFlow", component: RequestFlow, isLogin: true, title: '申请流程', views: true },
];

export default routers;
